export class AppraisalFilter {
  public equipmentTypeId;
  public equipmentModelId;
  public equipmentImei;
  public equipmentSerial;
  public os;
  public invoiceNumber;
  public jiraTicket;
  public reusable;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/filter/appraisal-filter.ts